import { CSP_NONCE, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env';

import { AppModule } from './app/app.module';
import { getNonce } from './app/csp-nonce.provider';

if (environment.production) {
    enableProdMode();
}

// Get and initialize CSP nonce BEFORE Angular bootstrap
// This patches document.createElement and adds nonce to existing styles
const nonce = getNonce();

platformBrowserDynamic([{ provide: CSP_NONCE, useValue: nonce }])
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.log(err));
